import {Collection} from 'vue-mc'
import {RegisteredClass} from './RegisteredClass'

class RegisteredClassList extends Collection {
  options () {
    return {
      model: RegisteredClass
    }
  }
}

export {RegisteredClassList}



//////////////////
// WEBPACK FOOTER
// ./src/models/RegisteredClassList.js
// module id = 887
// module chunks = 1